<template>
  <div>
    <toubu />
    <appmain />
  </div>
</template>
<script>
import toubu from "./components/toubu.vue";
import appmain from "./components/appmain.vue";
export default {
  components: {
    toubu,
    appmain
  },
};
</script>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue